"use client";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Award, Brain, Sparkles, Users } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const coachingTopics = [{
  id: 1,
  icon: Award,
  title: "Exam Confidence",
  description: "Build unshakeable confidence for exams with proven strategies and mindset techniques."
}, {
  id: 2,
  icon: Brain,
  title: "Focus & Concentration",
  description: "Master focus techniques to eliminate distractions and maximise study efficiency."
}, {
  id: 3,
  icon: Sparkles,
  title: "Motivation & Drive",
  description: "Discover what motivates you and maintain momentum throughout your learning journey."
}, {
  id: 4,
  icon: Users,
  title: "Interview Skills",
  description: "Develop the skills and confidence to excel in school interviews and oral assessments."
}];
export default function CoachingAndPersonalDevelopment() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section ref={ref} className="relative min-h-screen bg-gradient-to-br from-light-background via-primary-light to-accent-light py-20 overflow-hidden">
      {}
      <svg className="absolute left-0 top-0 h-full w-auto opacity-5 pointer-events-none" viewBox="0 0 200 800" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 0 Q80 200 100 400 Q120 600 100 800" stroke="currentColor" strokeWidth="8" className="text-primary" />
        <path d="M100 150 L60 180 M100 150 L140 180" stroke="currentColor" strokeWidth="4" className="text-accent" />
        <path d="M100 350 L70 390 M100 350 L130 390" stroke="currentColor" strokeWidth="4" className="text-accent" />
        <path d="M100 550 L65 590 M100 550 L135 590" stroke="currentColor" strokeWidth="4" className="text-accent" />
      </svg>

      <div className="container mx-auto px-6 relative z-10">
        {}
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className={`text-4xl md:text-5xl font-display font-bold text-primary mb-4 transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            Coaching and Personal Development
          </h2>
          <p className={`text-lg text-muted-foreground transition-all duration-[var(--duration-medium)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            Beyond academics, we focus on building the confidence, focus, and mindset students need to truly excel.
          </p>
        </div>

        {}
        <div className="relative max-w-6xl mx-auto">
          {}
          <div className="absolute left-1/2 top-0 bottom-0 w-0.5 bg-secondary/30 hidden lg:block -translate-x-1/2">
            <div className={`w-full bg-secondary origin-top transition-all duration-[var(--duration-slow)] delay-300 ${isVisible ? "scale-y-100" : "scale-y-0"}`} style={{
            height: "100%"
          }} />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {coachingTopics.map((topic, i) => {
            const Icon = topic.icon;
            return <Card key={topic.id} data-index={i} className={`bg-white/80 backdrop-blur-sm border-2 border-muted hover:border-secondary hover:-translate-y-2 hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
              animationDelay: `${i * 150}ms`
            }}>
                  <CardHeader className="text-center">
                    <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-gradient-to-br from-primary to-accent flex items-center justify-center shadow-medium">
                      <Icon className="w-8 h-8 text-white" />
                    </div>
                    <CardTitle className="text-xl text-primary">{topic.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-center text-muted-foreground leading-relaxed">
                      {topic.description}
                    </CardDescription>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>

        {}
        <div className="text-center mt-16">
          <Link to="/ProgrammesPage" className={`inline-flex items-center justify-center rounded-md bg-secondary text-foreground-secondary px-8 py-4 font-semibold text-lg hover:bg-secondary-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-secondary-active active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${isVisible ? "animate-fade-in-up-delay-200" : "opacity-0"}`}>
            Explore Our Programmes
          </Link>
        </div>
      </div>
    </section>;
}